import { Progress } from "@/components/ui/progress";
import { getWorkflowsProgressPercentage } from "@/helpers/tcs200";

export const WorkflowsProgress = (
  { workflowsCount }: { workflowsCount: number }
) => (
  <div className="card text-primary bg-foreground rounded-md p-5 tcsWorkflowCard">
    <h3 className="font-semibold text-left text-3xl leading-8 mb-2">
      {Math.floor(workflowsCount)} <span className="font-semibold text-secondary text-lg leading-5">/ 200 </span>
    </h3>
    <p className="text-left text-secondary text-base mb-5">
      Active Workflows
    </p>
    <div className="w3-progress-container w3-round-xlarge">
      <Progress value={getWorkflowsProgressPercentage(workflowsCount)} />
    </div>
  </div>
)
